/* global localStorage */

import './polyfills'
import BasketController from './controllers/basket'
import Category from './models/category'
import DeliveryArea from './models/delivery-area'
import Discount from './models/discount'
import ENUM from './lib/enums'
import moment from 'moment'
import PaymentMethod from './models/payment-method'
import Restaurant from './models/restaurant'
import TimeWindow from './models/time-window'
import Utils from './lib/utils'
import { helperInit } from './lib/helpers'


helperInit()
// Debugging
const params = new URLSearchParams(window.location.search)
if (!params.has('debug')) {
  console.debug = () => {}
  console.info = () => {}
  console.log = () => {}
}

class BasketInitiator {
  constructor({
    categories,
    currentDelivery,
    currentRestaurant,
    deliveryType,
    mode,
    page,
    products,
    showToastFunction,
    time
  } = {}) {
    // Clear the basket on step 5
    if (page === ENUM.PAGE.SUCCESS) {
      localStorage.removeItem(ENUM.Persistence.BASKET)
      localStorage.removeItem(ENUM.Persistence.LAST_INTERACTION_TIME)
      return
    }

    this.serverDateTime = Utils.normalizeServerTime(time)

    let restaurant = new Restaurant()
    restaurant.id = currentRestaurant.Id
    restaurant.name = currentRestaurant.Name
    restaurant.url = currentRestaurant.Urls.Restaurant
    restaurant.cartUrl = currentRestaurant.Urls.Cart
    restaurant.orderUrl = currentRestaurant.Urls.OrderUrl
    restaurant.domain = currentRestaurant.Urls.Domain
    restaurant.onlineStatus = parseInt(currentRestaurant.Open)
    restaurant.deliveryType = currentRestaurant.Pickup
    restaurant.deliveryAreaId = currentDelivery
      ? currentDelivery.postcode
      : null
    restaurant.autoAddProducts = currentRestaurant.Settings.AutoAddedProducts
    restaurant.translations = currentRestaurant.Translations
    restaurant.currency = currentRestaurant.Currency
    restaurant.dynamicDeliveryCosts = currentRestaurant.dynamicDeliveryCosts

    // Category opening and exception times
    let processedCategories = []
    for (let id in categories) {
      const data = categories[id]
      let category = new Category()
      category.id = id
      for (let x in data) {
        if (x === 'exceptions') {
          const exceptions = data[x]
          for (let xx in exceptions) {
            const exception = exceptions[xx]
            let timeWindow = new TimeWindow()
            timeWindow.date = Utils.getDate(moment(exception.date))
            timeWindow.startTime = moment(exception.startTime, 'HH:mm:ss')
            timeWindow.endTime = moment(exception.endTime, 'HH:mm:ss')
            category.exceptionTimes.push(timeWindow)
          }
          continue
        }
        const orderTime = data[x]
        let timeWindow = new TimeWindow()
        timeWindow.weekDay = orderTime.weekDay
        timeWindow.startTime = moment(orderTime.startTime, 'HH:mm:ss')
        timeWindow.endTime = moment(orderTime.endTime, 'HH:mm:ss')
        category.orderTimes.push(timeWindow)
      }
      processedCategories.push(category)
    }
    restaurant.categories = processedCategories
    restaurant.validateCategoriesOrderTime(this.serverDateTime)

    // Restaurant opening and exception times.
    restaurant.openingTimes = this.parseOpeningTimes(currentRestaurant.Times.deliveryopentimes)
    restaurant.pickupOpeningTimes = this.parseOpeningTimes(currentRestaurant.Times.pickupopentimes)
    restaurant.exceptionTimes = this.parseExceptionTimes(currentRestaurant.Times.exceptionsdelivery)
    restaurant.pickupExceptionTimes = this.parseExceptionTimes(currentRestaurant.Times.exceptionspickup)

    /**
     *
     * Set delivery areas of the restaurant
     *
     */

    if (currentDelivery) {
      let deliveryAreas = []
      let deliveryAreasSource

      if (currentDelivery.searchType === 'postcode') { // Postcode search
        deliveryAreasSource = currentRestaurant.Locations
      } else if (currentDelivery.searchType === 'address') {// Polygon/address search
        deliveryAreasSource = [currentRestaurant.Polygons[currentDelivery.polygonIndex]]
      }
      console.log('currentDeliverySearchType', currentDelivery.searchType)
      console.log('deliveryAreasSource', deliveryAreasSource)

      for (let x in deliveryAreasSource) {
        let data = deliveryAreasSource[x]
        let deliveryArea = new DeliveryArea()
        deliveryArea.id = data.deliveryareaid.toString()
        deliveryArea.minimumOrderAmount = data.minimumcosts
        deliveryArea.deliveryCosts = data.costs
        // Get the maximum till value for the area, which means noDeliveryCostsFrom that value

        let costLastTill = 0.0
        let costFreeFrom = 0.0

        for (let costDataIndex in data.costs) {
          let costData = data.costs[costDataIndex]

          if (costLastTill < costData.till && costData.till != 0) {
            costLastTill = costData.till
          }

          if (costData.till == 0) {
            costFreeFrom = false
          }
        }

        deliveryArea.noDeliveryCostsFrom = costFreeFrom !== false ? parseFloat(costLastTill) : 0.0
        deliveryAreas.push(deliveryArea)
      }

      restaurant.deliveryAreas = deliveryAreas
      console.log('restaurant.deliveryAreas', restaurant.deliveryAreas)
    }

    /**
     *
     * Set payment methods
     *
     */

    let paymentMethods = []
    if (currentRestaurant.Settings.PaymentMethods !== undefined) {
      for (let x in currentRestaurant.Settings.PaymentMethods) {
        let paymentDetail = currentRestaurant.Settings.PaymentMethods[x]
        let paymentMethod = new PaymentMethod()
        paymentMethod.id = paymentDetail.id
        paymentMethod.mainId = paymentDetail.mainId
        paymentMethod.subId = paymentDetail.subId
        paymentMethod.name = paymentDetail.name
        paymentMethod.transactionFixed = paymentDetail.fixed
        paymentMethod.transactionPercentage = paymentDetail.percentage
        paymentMethods.push(paymentMethod)
      }
    }
    restaurant.paymentMethods = paymentMethods

    let discount
    for (let x in currentRestaurant.Settings.Discounts) {
      let value = currentRestaurant.Settings.Discounts[x]
      discount = new Discount()
      discount.id = value.id
      discount.type = parseInt(value.type)
      discount.deliveryType = parseInt(value.deliverytype)
      discount.amount = value.discountamount
      discount.from = value.discountfrom
      discount.number = value.discountnumber
      discount.percentage = value.discountpercentage
      discount.specialPrice = value.discountprice
      discount.productIds2D = value.productsids
      discount.description = value.text
      discount.discountName = value.title
      discount.isDiscountRepeat = value.anynumber
      discount.inclusiveSidedishes = value.includeSidedishes
      let date = new TimeWindow()
      date.weekDay = (value.day !== null) ? parseInt(value.day) : -1
      discount.date = date
      restaurant.discounts.push(discount)
    }

    let basket
    try {
      basket = new BasketController({
        products: products,
        deliveryType: deliveryType,
        mode: mode,
        restaurant: restaurant,
        showToastFunction: showToastFunction,
        page: page,
        serverDateTime: this.serverDateTime,
      })
    } catch (e) {
      // Fail silently
      basket = null
    }

    if (page === ENUM.PAGE.CHECKOUT) {
      /**
       * Select the payment method that is set in local storage.
       * @default select the first possible payment method.
       */
      var selectPaymentMethodByLocalStorage = function () {
        if (basket.getPaymentMethod() === null) {
          // This is from Checkout.js.
          basket.selectFirstPossiblePaymentMethod()
        } else {
          // This is from Checkout.js.
          basket.selectPaymentMethodById(basket.getPaymentMethod().id)
        }
      }
      selectPaymentMethodByLocalStorage()
      console.log('Basket: selectPaymentMethodByLocalStorage()')

      /**
       * Cut/paste from Checkout.js
       */
      let e = $('#ideliverytime, #ipickuptime')[0]
      if (e.options.selectedIndex === -1) {
        return
      }
      let selectedTime = e.options[e.options.selectedIndex]
      basket.validateDeliveryTime(selectedTime.value)
    }

    // Bad code
    // Check if there is a basketValidationResponse and update the basket with it.
    if (basket) {
      if (window.basketValidationResponse !== undefined) {
        basket.updateBasketAfterValidation(window.basketValidationResponse)
      } else {
        basket.updateUI()
      }
    }

    /**
     * =====================================================
     * EVENT HANDLERS
     * =====================================================
     **/

    $(document).ready(function () {
      /**
       * Click outside the remark and close it. Very ugly check with jQuery.
       */
      $(document.body).click(function (e) {
        if (
          e.target.className === 'cart-meal-textarea' ||
          e.target.className === 'div.cart-meal-edit-comment'
        ) {
          return
        }
        if (basket) {
          basket.closeProductComment(e, basket.selectedProductCommentId, true)
        }
      })
    })

    return basket
  }

  parseOpeningTimes(datas) {
    let openingTimes = []
    for (let x in datas) {
      let data = datas[x]
      for (let xx in data) {
        let openingTime = data[xx]
        let timeWindow = new TimeWindow()
        timeWindow.weekDay = parseInt(x)
        timeWindow.startTime = moment(openingTime.starttime, 'HH:mm')
        timeWindow.endTime = moment(openingTime.endtime, 'HH:mm')
        openingTimes.push(timeWindow)
      }
    }
    return openingTimes
  }

  parseExceptionTimes(datas) {
    let openingTimes = []
    for (let x in datas) {
      let openingTime = datas[x]
      let start = moment(openingTime.starttime * 1000)
      let end = moment(openingTime.endtime * 1000)
      let timeWindow = new TimeWindow()
      timeWindow.date = Utils.getDate(start)
      timeWindow.startTime = moment({ hour: start.hours(), minute: start.minutes() })
      timeWindow.endTime = moment({ hour: end.hours(), minute: end.minutes() })
      openingTimes.push(timeWindow)
    }
    return openingTimes
  }
}

export { BasketInitiator, ENUM }

// Dirty hack for version2
window.BasketInitiator = BasketInitiator
window.ENUM = ENUM
